import DigitalAssetsPage from 'apex-web/lib/components/DigitalAssets/DigitalAssetsPageContainer';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import './DigitalAssets.css';

const classes = getBEMClasses('digital-assets-page');

const DigitalAssets = () => {
  return (
    <div className="digital-assets-page">
      <div className="digital-assets-page__content">
        <DigitalAssetsPage />
      </div>
      <div className={classes('footer-new')}>
        <PageFooterLayout />
      </div>
    </div>
  );
};

export default DigitalAssets;
